/**
 * @generated SignedSource<<45f62c31f78a80a441e74cfc2d27fbec>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Query } from 'relay-runtime';
export type recoilGetPreparersQuery$variables = {
  user_ids?: ReadonlyArray<number> | null;
};
export type recoilGetPreparersQuery$data = {
  readonly sys_users: ReadonlyArray<{
    readonly sakura_user: {
      readonly first_name: string | null;
      readonly last_name: string | null;
    } | null;
    readonly user_id: number;
  }>;
};
export type recoilGetPreparersQuery = {
  response: recoilGetPreparersQuery$data;
  variables: recoilGetPreparersQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "user_ids"
  }
],
v1 = [
  {
    "alias": null,
    "args": [
      {
        "fields": [
          {
            "fields": [
              {
                "kind": "Variable",
                "name": "_in",
                "variableName": "user_ids"
              }
            ],
            "kind": "ObjectValue",
            "name": "user_id"
          }
        ],
        "kind": "ObjectValue",
        "name": "where"
      }
    ],
    "concreteType": "sys_users",
    "kind": "LinkedField",
    "name": "sys_users",
    "plural": true,
    "selections": [
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "user_id",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "concreteType": "sakura_user",
        "kind": "LinkedField",
        "name": "sakura_user",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "first_name",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "last_name",
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "recoilGetPreparersQuery",
    "selections": (v1/*: any*/),
    "type": "query_root",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "recoilGetPreparersQuery",
    "selections": (v1/*: any*/)
  },
  "params": {
    "cacheID": "0fdf072b5517af98529dca68c0da791e",
    "id": null,
    "metadata": {},
    "name": "recoilGetPreparersQuery",
    "operationKind": "query",
    "text": "query recoilGetPreparersQuery(\n  $user_ids: [Int!]\n) {\n  sys_users(where: {user_id: {_in: $user_ids}}) {\n    user_id\n    sakura_user {\n      first_name\n      last_name\n    }\n  }\n}\n"
  }
};
})();

(node as any).hash = "793781275aadde2744ba139cb6a7fc41";

export default node;
